import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, ViewChild, EventEmitter } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { AutoRoutingService } from '../../../../services/auto-routing.service';
import { BooleanCheckComponent } from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { StandingOrderRenderer } from '../../../A2-utils/grid-components/standing-order-render/standing-order-render.component';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';

@Component({
  selector: 'app-auto-routing-unassign',
  templateUrl: './auto-routing-unassign.component.html',
  styleUrls: ['./auto-routing-unassign.component.scss']
})
export class AutoRoutingUnassignComponent implements OnInit, OnChanges {

  gridTrips: GridOptions;
  @Input() jobId?: number;
  @Input() tripsUnassigned?: any[] = [];
  @Input() driver?: any[] = [];
  @Output() onReloadUnassigned?: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPointsSelected?: EventEmitter<any> = new EventEmitter<any>();

  tripid: number;

  @ViewChild('assignTrip') assignTrip: T2CardComponent;

  constructor( private _autoRoutingService: AutoRoutingService) {
    this.gridTrips = <GridOptions>{};
    this.gridTrips.columnDefs = this.createDef();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tripsUnassigned']) {
      if( this.gridTrips && this.gridTrips.api) {
        this.gridTrips.api.setRowData(this.tripsUnassigned);
      }
    }
  }
  onGridReady() {
    this.gridTrips.api.setRowData(this.tripsUnassigned);
  }

  createDef() {
    return  [
      { headerName: 'Check', colId: 'check', width: 30, checkboxSelection: true, headerCheckboxSelection: true, suppressFilter: true },
      { headerName: 'Provider', field: 'company', colId: 'company', width: 80, suppressToolPanel: true, suppressFilter: true },
      { headerName: 'Trip ID', field: 'consecutive', colId: 'consecutive', width: 70 },
      { headerName: 'Status', field: 'tripstatus', colId: 'status', width: 60 },
      { headerName: 'Driver Name', field: 'drivername', colId: 'drivername', width: 85 },
      { headerName: 'Reasons', field: 'reasons', colId: 'reasons', width: 85 },
      { headerName: 'Rider Information', children: [
        { headerName: 'Rider', field: 'ridername', colId: 'ridername', width: 150 },
          { headerName: 'Phone', field: 'riderphonenumber', colId: 'ridername', width: 150 },
          { headerName: 'Age', field: 'riderage', colId: 'ridername', width: 55 },
          { headerName: 'Payor', field: 'payor', colId: 'payor', width: 80 }
        ]
      },
      { headerName: 'Service', field: 'servicetype', colId: 'service', width: 80 },
      { headerName: 'Date', field: 'dateofservice', colId: 'date', width: 75 },
      { headerName: 'Leg', field: 'leg', colId: 'leg', width: 35 },
      { headerName: 'Appointment', field: 'appointmenttime', colId: 'appointmenttime', width: 80 },
      { headerName: 'Pick-Up', children: [
        { headerName: 'PU Time', field: 'pickup', colId: 'puTime', width: 120 },
          { headerName: 'ActualPU', field: 'actualpickup', colId: 'puTime', width: 120 },
          { headerName: 'Address', field: 'triplocationpickup.streetaddress', colId: 'puaddresss', width: 120 },
          { headerName: 'City', field: 'triplocationpickup.city', colId: 'puCity', width: 120 },
          { headerName: 'ZipCode', field: 'triplocationpickup.zip', colId: 'zipP', width: 120 },
          { headerName: 'Geo', field: 'iscoordpickupvalid', cellRendererFramework: BooleanCheckComponent, colId: 'iscoordpickupvalid', width: 120 },
          { headerName: 'County', field: 'triplocationpickup.county', colId: 'county', width: 120 }
        ]
      },
      { headerName: 'Drop-Off', children: [
        { headerName: 'Actual Drop', field: 'actualdropoff', colId: 'doaddresss', width: 120 },
          { headerName: 'Address', field: 'triplocationdropoff.streetaddress', colId: 'doaddresss', width: 120 },
          { headerName: 'Actual Drop', field: 'actualdropoff', colId: 'doaddresss', width: 120 },
          { headerName: 'City', field: 'triplocationdropoff.city', colId: 'doCity', width: 120 },
          { headerName: 'ZipCode', field: 'triplocationdropoff.zip', colId: 'zipD', width: 120 },
          { headerName: 'Geo', field: 'iscoorddropoffvalid', cellRendererFramework: BooleanCheckComponent, colId: 'iscoorddropoffvalid', width: 120 },
          { headerName: 'County', field: 'triplocationdropoff.county', colId: 'county', width: 120 }
        ]
      },
      { headerName: 'Companions', field: 'companions', colId: 'companions', width: 100 },
      { headerName: 'VIP', field: 'isridervip', cellRendererFramework: BooleanCheckComponent, colId: 'vip', width: 70 },
      { headerName: 'Confirmed', field: 'tripconfirmed', cellRendererFramework: BooleanCheckComponent, colId: 'tripconfirmed', width: 70 },
    ];
  }

  editTrip($event) {
    this.tripid = $event.data.tripid;
    this.assignTrip.open();

  }

  onRowSelected($event) {
    const selectedRows = this.gridTrips.api.getSelectedRows();
    const points = [];

    selectedRows.forEach((row) => {
      const obj = {
        consecutive: row.consecutive,
        pickup: {
          latitude: row.triplocationpickup.latitude,
          longitude: row.triplocationpickup.longitude
        },
        dropoff: {
          latitude: row.triplocationdropoff.latitude,
          longitude: row.triplocationdropoff.longitude
        }
      }
      points.push(obj);
    });
    this.onPointsSelected.emit(points);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/auto-routing-results/components/auto-routing-unassign/auto-routing-unassign.component.ts